import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';
import type { BusinessContextState } from '../types';

/**
 * Business Context Store
 * 
 * Used by super admins to select which business they're operating as.
 * Persists in sessionStorage so it survives page refreshes but not browser closes.
 */
export const useBusinessContextStore = create<BusinessContextState>()(
  persist(
    (set) => ({
      selectedBusinessId: null,
      selectedBusinessName: null,

      setSelectedBusiness: (businessId, businessName) => {
        set({
          selectedBusinessId: businessId,
          selectedBusinessName: businessName,
        });
      },

      clearSelectedBusiness: () => {
        set({
          selectedBusinessId: null,
          selectedBusinessName: null,
        });
      },
    }),
    {
      name: 'nailedit-business-context',
      storage: createJSONStorage(() => sessionStorage),
    }
  )
);